import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Breadcrumbs from "../../../../common/BreadCrum/BreadCrum";
import PageHeadingSection from "../../../../common/pageheading/PageHeadingSection";
import CommonTable from "../../../../common/table/ComonTable";
import apiServices from "../../../../../services/apiService";

const AllocationTypeList = () => {
    const { user } = useSelector((state) => state.auth);
    const siteId = user?.siteId;
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const load = async () => {
            if (!siteId) return;
            setLoading(true);
            try {
                const res = await apiServices({ method: "GET", url: `/AllocationTypeMaster/site/${siteId}` });
                if (res?.data?.isSuccess === false || res?.data?.IsSuccess === false) {
                    toast.error(res?.data?.message || res?.data?.Message || "Failed to load allocation types");
                    setRows([]);
                    return;
                }
                const data = res?.data?.Data || res?.data?.data || [];
                setRows(Array.isArray(data) ? data : []);
            } catch (error) {
                toast.error("Failed to load allocation types");
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [siteId]);

    const headers = [
        { key: "name", label: "ALLOCATION TYPE" },
        { key: "active", label: "ACTIVE" },
        { key: "created", label: "CREATED" }
    ];

    const tableRows = rows.map((row) => ({
        name: row.AllocationTypeName || row.allocationTypeName,
        active: (row.IsActive ?? row.isActive) ? "Yes" : "No",
        created: row.CreatedOn || row.createdOn ? new Date(row.CreatedOn || row.createdOn).toLocaleString() : "—"
    }));

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto gap-4">
            <Breadcrumbs />
            <PageHeadingSection
                mainHeading="Allocation Types"
                subHeading="Allocation types for this site. Pay and Park uses the type named Pay & Park."
            />
            <CommonTable tableHeading="Allocation Type Master" headers={headers} data={tableRows} isLoading={loading} renderCell={(key, row) => row[key]} />
        </div>
    );
};

export default AllocationTypeList;
